import { useCallback } from 'react';

import { Button } from '@mui/material';
import { ButtonProps } from '@mui/material/Button/Button';
import { useMutedCallback } from '@provider-portal/common/hooks/useMutedCallback';

export interface ButtonTestIds {
  save: string;
  cancel: string;
}
export interface ModalDialogTitleProps {
  actionLabel: string;
  cancelLabel: string;
  actionButtonColor?: ButtonProps['color'];
  actionDisabled?: boolean;
  onClickCancel: () => void;
  onClickAction?: () => void;
  testIds?: ButtonTestIds;
}

export function ModalDialogActions({
  actionLabel,
  cancelLabel,
  actionDisabled,
  onClickCancel,
  onClickAction,
  actionButtonColor = 'primary',
  testIds,
}: ModalDialogTitleProps) {
  const onClickCancelHandler = useMutedCallback(onClickCancel);
  const onClickActionHandler = useCallback(() => {
    if (onClickAction) {
      onClickAction();
    }
  }, [onClickAction]);

  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        onClick={onClickCancelHandler}
        data-testid={testIds?.cancel}
      >
        {cancelLabel}
      </Button>
      <Button
        variant="contained"
        color={actionButtonColor}
        type="submit"
        onClick={onClickActionHandler}
        disabled={actionDisabled}
        data-testid={testIds?.save}
      >
        {actionLabel}
      </Button>
    </>
  );
}
